'use strict';

const allThemes = state => {
  return state.themes;
};

const selectedThemeName = state => {
  return state.selectedThemeName;
};

const isHighContrastThemeActive = state => {
  return state.selectedThemeName === 'contrast';
};

const getThemeByName = state => name => {
  return state.themes.find(theme => theme.name === name);
};

export default {
  allThemes,
  selectedThemeName,
  isHighContrastThemeActive,
  getThemeByName
};
